<ion-header class="ion-no-border">
  <ion-toolbar class="no-height bg-primary"> </ion-toolbar>
</ion-header>
